// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/98f13e08eea86ea194bb.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"dbb8c1e38e06582be6bd","267":"ce94e31082c77a54aaae","268":"3f0458be25e5c3c26730"}[chunkId] + ".chunk.js";
};